module.exports = __webpack_public_path__ + "images/google_logo.svg";